module.exports = __webpack_public_path__ + "img/icon-third.685fd38b.png";